export default [
    {
        "consentType": "5",
        "consentIndicator": null,
        "planNumber": "805222"
    },
    {
        "consentType": "28",
        "consentIndicator": false,
        "planNumber": "805222"
    },
    {
        "consentType": "33",
        "consentIndicator": true,
        "planNumber": "805222"
    },
    {
        "consentType": "34",
        "consentIndicator": true,
        "planNumber": "805222"
    },
    {
        "consentType": "35",
        "consentIndicator": true,
        "planNumber": "805222"
    },
    {
        "consentType": "25",
        "consentIndicator": true,
        "planNumber": "805222"
    },
    {
        "consentType": "30",
        "consentIndicator": null,
        "planNumber": "805222"
    },
    {
            "consentType": "23",
            "consentIndicator": null,
            "planNumber": "504867"
        },
    {
            "consentType": "24",
            "consentIndicator": null,
            "planNumber": "504867"
        },
    {
            "consentType": "51",
            "consentIndicator": null,
            "planNumber": "504867"
        },
    {
            "consentType": "52",
            "consentIndicator": true,
            "planNumber": "504867"
        },
    {
        "consentType": "57",
        "consentIndicator": false,
        "planNumber": "504867"
    },
    {
        "consentType": "58",
        "consentIndicator": false,
        "planNumber": "504867"
    },

]
